import { useRef } from 'react';
import useActionableAnnotation from 'src/components/ActionableTooltip/useActionableAnnotation';
import {
  Box,
  Button,
  Link,
  Paper,
  Popper,
  Typography
} from '@mui/material';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import { requestAdminNavigation } from 'src/navigation/adminNavigationGuard';

export default function QuoteApprovalCaution({ eventId }: { eventId: number }) {
  const annotation = useActionableAnnotation<HTMLButtonElement>({ enabled: true });
  const { anchor, open, pinned, close } = annotation;
  const suppressFocus = useRef(false);
  const detailId = `quote-approval-caution-${eventId}`;
  return (
      <Box
        onMouseEnter={annotation.preview}
        onMouseLeave={(event) => {
          if (!pinned && !event.currentTarget.contains(document.activeElement))
            annotation.hidePreview();
        }}
        onFocus={() => {
          if (suppressFocus.current) suppressFocus.current = false;
          else annotation.preview();
        }}
        onBlur={(event) => {
          if (!pinned && !event.currentTarget.contains(event.relatedTarget as Node))
            close();
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            event.stopPropagation();
            close();
            if (document.activeElement !== anchor.current) {
              suppressFocus.current = true;
              anchor.current?.focus();
            }
          }
        }}
      >
        <Button
          ref={anchor}
          size="small"
          startIcon={<WarningAmberRounded fontSize="small" />}
          aria-expanded={open}
          aria-controls={open ? detailId : undefined}
          onClick={annotation.pin}
          sx={{
            color: '#795800',
            bgcolor: '#fff6d8',
            border: '1px solid #e6ce82',
            borderRadius: 1.5,
            fontSize: 12,
            textTransform: 'none'
          }}
        >
          Quote Not Approved
        </Button>
        <Popper
          open={open}
          anchorEl={anchor.current}
          placement="top-start"
          disablePortal
          sx={{
            zIndex: (theme) => theme.zIndex.tooltip,
            maxWidth: 'calc(100vw - 32px)'
          }}
        >
          <Paper
            ref={annotation.content}
            id={detailId}
            elevation={6}
            sx={{
              p: 2,
              mb: 1,
              width: 340,
              maxWidth: '100%',
              whiteSpace: 'normal',
              border: '1px solid #e6ce82'
            }}
          >
            <Typography variant="body2" sx={{ mb: 1 }}>
              Publishing opens worker bidding; it does not approve the quote or
              change deposits.
            </Typography>
            <Link
              href={`/dashboards/jobTracker/positions/${eventId}?tab=quote`}
              onClick={(event) => {
                close(event);
                const path = `/dashboards/jobTracker/positions/${eventId}?tab=quote`;
                if (!requestAdminNavigation(() => window.location.assign(path)))
                  event.preventDefault();
              }}
            >
              Review Quote
            </Link>
          </Paper>
        </Popper>
      </Box>
  );
}
